<app-dialog-heading [heading]="data.heading"></app-dialog-heading>

<div class="iframe-container">
  <iframe height="100%" width="100%" frameBorder="0" scrolling="no" 
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms" 
          referrerpolicy="no-referrer" 
          allowFullScreen 
          [src]="safeUrl">
  </iframe>
</div>

<mat-dialog-actions align="center" class="dialog-button-container flex justify-center">
  <button class="dialog-button" mat-raised-button (click)="onClickOkay()" color="primary">Okay</button>
</mat-dialog-actions>
